import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "List of Health Innovations and Partners")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_DataTable, {
        value: _ctx.partnerList,
        paginator: true,
        rows: 10,
        selection: _ctx.selectedPartners,
        "onUpdate:selection": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedPartners) = $event)),
        dataKey: "id",
        responsiveLayout: "scroll",
        class: "p-datatable-customers",
        loading: _ctx.loading
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Column, { header: "#" }, {
            body: _withCtx(({ index }) => [
              _createTextVNode(_toDisplayString(index + 1), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "heathInnovation",
            header: "Health Innovation",
            sortable: true,
            headerStyle: "width: 60%"
          }, {
            body: _withCtx(({ data }) => [
              _createVNode(_component_router_link, {
                to: `/partners/partner-on-proposal/${data.id}?id=${data.id}`
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(data.heathInnovation), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "partners",
            header: "Partners",
            sortable: true
          })
        ]),
        _: 1
      }, 8, ["value", "selection", "loading"])
    ])
  ]))
}